import { TerramapApi } from "./api"
import { Filters } from "./filters"
import { getSetsFromImports, updateSelection } from "./selection"
import { State } from "./state"
import { ManagementTask, ParametersWithFields, SelectedLayerType, Selection } from "./types"

export type Dispatch = React.Dispatch<Action>

export type ActionPayload<ActionType extends Action["type"]> = Extract<Action, { type: ActionType }>

export type Action =
    | {
        // Return to the "index" state
        type: "index"
    }
    | {
        // Refresh the data, and return to "index"
        type: "refresh",
        data: Pick<State, "layers" | "imports" | "tasks" | "sets" | "reference" | "selection">
    }
    | {
        // Set the current selection
        type: "setSelection",
        selection: Selection
    }
    | {
        // Set the current field
        type: "setSelectedField",
        fieldKey: string
    }
    | {
        // Set the current layer type
        type: "setLayerType",
        layerType: SelectedLayerType
    }
    | {
        // Switch to the "set parameters" mode
        type: "startSetParameters"
    }
    | {
        // Update parameters
        type: "updateParameters",
        update: Partial<ParametersWithFields>
    }
    | {
        // Add new management tasks
        type: "addMgmtTasks",
        newTasks: ManagementTask[]
    }
    | {
        // Set layer viewer options
        type: "setLayerViewerOptions",
        update: Partial<State["layerViewerOptions"]>
    }


export async function dispatchSetSelection(dispatch: Dispatch, api: TerramapApi, state: State, filters: Filters) {

    const { sets, layers, reference: { fields, layerTypes } } = state

    const context = { sets, layers, fields, layerTypes, filters: state.selection }

    const selection = await updateSelection(api, context, filters)

    dispatch({ type: "setSelection", selection })

}

export async function dispatchRefresh(dispatch: Dispatch, api: TerramapApi, selection: Selection, refresh?: { auto: boolean }) {

    const apiData = await api.load(refresh)

    const {
        imports,
        tasks,
        layerTypes,
        fields,
        layers
    } = apiData

    const sets = getSetsFromImports(imports)

    const { filters } = selection

    const context = {
        layers,
        sets,
        fields,
        layerTypes,
        filters
    }

    selection = await updateSelection(api, context, filters)

    const data = {
        layers,
        imports,
        sets,
        tasks,
        selection,
        reference: {
            fields,
            layerTypes
        }
    }

    dispatch({ type: "refresh", data })

}
